import React from 'react'
import Favorite from 'components/Artworks/Actions/Favorites/Action'
import { MetaItem } from '../styles/products'

export type MetaSegmentProps = {
  artworkId?: number
  count: number
  type: string
}

const MetaSegment = (
  props: MetaSegmentProps
): React.ReactElement<React.ComponentProps<any>, any> => {
  const { artworkId, count, type } = props

  if (type === 'Views') {
    return (
      <MetaItem data-meta data-type='views'>
        <p className='defaultTypographySmall'>{`${count} `} Views</p>
      </MetaItem>
    )
  }

  if (type === 'Likes') {
    return (
      <MetaItem data-meta data-type='favorite'>
        <Favorite artworkId={Number(artworkId)} dataStyle='profile' />
        <p className='defaultTypographySmall'>{count}</p>
      </MetaItem>
    )
  }

  // Default layout. Keep as sole return when abtest is complete.
  return (
    <MetaItem>
      <p className='defaultTypographySmall'>{count}</p>
      <p className='defaultTypographySmall'>{type === 'Views' ? 'Views' : 'Favorites'}</p>
    </MetaItem>
  )
}

export default MetaSegment
